import React from 'react'
import { Chart } from 'react-google-charts'

const isMobile = window.innerWidth < 600

export default class BarChart extends React.Component<Props, State> {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      <>
        {/* https://developers.google.com/chart/interactive/docs/gallery/columnchart */}
        <Chart
          width='100%'
          height='300px'
          chartType='ColumnChart'
          loader={<div>Grafik wird geladen</div>}
          data={[
            ['Jahr', 'Männlich',{ role: 'annotation' }, 'Weiblich', { role: 'annotation' }],
            ['2009', 9, '9', 16, '16'],
            ['2010', 7, '7',19,'19'],
            ['2011', 6, '6',21,'21'],
            ['2012', 8, '8',14,'14'],
            ['2013', 5, '5',18,'18'],
            ['2014', 6, '6',17,'17'],
            ['2015', 14, '14',22,'22'],
            ['2016', 1, '1',18,'18'],
            ['2017', 4,'4', 17,'17'],
            ['2018', 3,'3', 24,'24']
          ]}
          options={{
            bar: { groupWidth: '80%' },
            colors: ['#fff', '#F16067'],
            backgroundColor: 'transparent',
            allowHtml: true,
            bars: 'vertical',
              chartArea: {
                top: '20%',
                left: isMobile ? '6.5%' : '3.5%',
                right: '2%',
                bottom: '10%'
              },
            textStyle: {
                color: '#fff',
                fontName: 'IBM Plex Sans',
            },
            hAxis: {
              textPosition: 'bottom',
              gridlines: {
                color: '#7d7d7d',
              },
              baselineColor: '#7d7d7d',
              minValue: 0,
              textStyle: {
                fontSize: isMobile ? 12 : 13,
                color: '#7d7d7d',
                fontName: 'IBM Plex Sans'
              }
              
            //   viewWindow: {
            //     max: 100
            //   }
            },
            tooltip: { isHtml: true},
            vAxis: {
              textStyle: {
                fontSize: isMobile ? 12 : 13,
                color: '#7d7d7d',
                fontName: 'IBM Plex Sans'
              },
            //   maxValue: 30,
              gridlines: {
                color: '#7d7d7d',
                count: 4,
              },
              baselineColor: '#7d7d7d',
            },
            legend: { position: 'top', maxLines: 2, textStyle: {color: '#fff', fontName: 'IBM Plex Sans'} },
            enableInteractivity: false,
            annotations: {
              textStyle: {
                fontSize: isMobile ? 12 : 14
              }
            }
          }}
        />
      </>
    )
  }
}
